const AppVisibility = {
  PUBLIC: 1,
  PRIVATE: 2,
};

Object.freeze(AppVisibility);

export default AppVisibility;